<p>user-recommended-session works!</p>
